export type WatermarkClass = 'MANAGEMENT' | 'AGENCY' | 'CREATOR' | 'STAFF' | 'PUBLIC';

/** GET/PUT /watermark/admin/config (hp-media-server-staging/src/watermark/watermark.service.ts view()). */
export interface WatermarkConfigView {
  appEnabled: boolean;
  appClasses: WatermarkClass[];
  adminEnabled: boolean;
  showName: boolean;
  showTiktokId: boolean;
  showTiktokUid: boolean;
  showPhoneTail: boolean;
  showTime: boolean;
  /** % alpha lớp chữ. */
  opacityPct: number;
  hiddenLayer: boolean;
  /** Vị trí app TẮT watermark. */
  appOffPositions: string[];
  /** Khoá nhóm menu (nav-config) TẮT watermark; "home" = Tổng quan. */
  adminOffGroups: string[];
  updatedAt: string | null;
  updatedBy: number | null;
  meta: {
    classes: { value: WatermarkClass; label: string }[];
    appPositions: { value: string; label: string }[];
    opacityPct: { min: number; max: number; default: number };
    hiddenOpacity: number;
  };
  preview: {
    lines: string[];
    parts: { name: string; tiktokId: string; tiktokUid: string; phoneTail: string };
    code: string;
  };
}

/** GET /watermark/admin/lookup?code= */
export interface WatermarkLookupResult {
  found: boolean;
  reason?: 'FORMAT' | 'NOT_FOUND';
  code?: string;
  checkValid?: boolean;
  message: string;
  user?: {
    id: number;
    nickName: string;
    username: string | null;
    email: string;
    tiktokUid: string | null;
    roles: string[] | string;
    department: string | null;
    isHpCompany: boolean;
    isAccountDisabled: boolean;
    deletedAt: string | null;
    avatar: string | null;
    userClass: WatermarkClass | null;
  };
}

/** Câu lỗi tiếng Việt: WatermarkError gửi câu ở `error`, class-validator gửi mảng ở `message`. */
export function watermarkError(err: any, fallback = 'Có lỗi xảy ra, vui lòng thử lại.'): string {
  if (err?.networkError) return 'Không kết nối được máy chủ.';
  if (
    typeof err?.error === 'string' &&
    err.error &&
    !/^(Bad Request|Not Found|Internal Server Error)$/i.test(err.error)
  ) {
    return err.error;
  }
  if (Array.isArray(err?.message)) return err.message.join('; ');
  const status = err?.statusCode || err?.status;
  if (status === 404) return 'Máy chủ chưa có tính năng watermark (cần deploy bản backend mới).';
  if (status >= 500) return 'Lỗi máy chủ, vui lòng thử lại sau.';
  return fallback;
}
